import Box from '@mui/material/Box';
import { Suspense, useState } from 'react';
import { Outlet } from 'react-router';
import { InactivityLogout } from '@/features/auth/logout';
import { CommandPalette, PaletteButton } from '@/features/command-palette';
import { FullPageLoader } from '@/shared/ui';
import { AppHeader } from '@/widgets/header';
import { ScreenTabs } from '@/widgets/screen-tabs';
import { AppSidebar } from '@/widgets/sidebar';

export function DashboardLayout() {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <Box
      className="md-print-flow"
      sx={{ display: 'flex', height: '100dvh', overflow: 'hidden', bgcolor: 'background.default' }}
    >
      <InactivityLogout />
      <CommandPalette />
      <Box className="md-no-print" sx={{ display: 'contents' }}>
        <AppSidebar mobileOpen={mobileOpen} onMobileClose={() => setMobileOpen(false)} />
      </Box>
      <Box
        className="md-print-flow"
        sx={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', height: '100dvh' }}
      >
        <Box className="md-no-print" sx={{ display: 'contents' }}>
          <AppHeader onMenuClick={() => setMobileOpen(true)} actions={<PaletteButton />} />
          <ScreenTabs />
        </Box>
        <Box
          component="main"
          className="md-print-flow"
          sx={{ flex: 1, overflow: 'auto', p: { xs: '20px 16px 40px', sm: '26px 22px 44px' } }}
        >
          {/*
            Section blocks (stat grids, headings, distribution panels) carry their own bottom
            margin so they stack evenly. On the last block that margin is dead space above the
            main padding, so it is dropped here rather than in every component.
          */}
          <Box
            sx={{
              maxWidth: 1460,
              mx: 'auto',
              '& > * > :last-child': { mb: 0 },
            }}
          >
            <Suspense fallback={<FullPageLoader />}>
              <Outlet />
            </Suspense>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
